import { redirect, Navigate, Route, useRouteError } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Layout from '@/components/Layouts/BaseLayout'
import ErrorPage from '@/pages/ErrorPage'
import Login from '@/pages/login'
import NoFind from '@/pages/NoFind'
import TestPage from '@/pages/test'
import ComponentsExample from '@/pages/example/components'
import BaseComponentStableSearch from '@/components/TableSearch/example/base'
import BaseComponentSlickGrid from '@/components/SlickGrid/example/base'
import EditComponentSlickGrid from '@/components/SlickGrid/example/edit'

// multiHeader
import MultiHeaderComponentSlickGrid from '@/components/SlickGrid/example/multiHeader'
import RowGroupSlickGrid from '@/components/SlickGrid/example/rowGroup'
import TreeComponentSlickGrid from '@/components/SlickGrid/example/tree'
import LazySlickgridSlickGrid from '@/components/SlickGrid/example/lazy'
import HeartCheck from '@/common/hooks/example/HeartCheck'
import ReactQueryDemo from '@/pages/example/pages/react-query'
import NumberRangeDemo from '@/components/NumberRange/example/index'
import DataSourceSelectDemo from '@/components/DataSourceSelect/example/index'
import { getStorage } from '@/utils/tools'
// import SplitPlanList from '@/pages/cost/split'
// import TemplateList from '@/pages/template/list'
// import GvTemplateList from '@/pages/gvTemplate/list'
// import GvTemplateSetting from '@/pages/gvTemplate/setting'
// import FieldList from '@/pages/field/list'
import { DefaultSystemKey } from '@/config'
import Loading from '@/pages/other/Loading'
import OtherUpload from '@/pages/other/upload'
import DocumentList from '@/pages/documentCompile/project/index'
import DocumentDetail from '@/pages/documentCompile/project/detail'
import DirPage from '@/pages/documentCompile/project/dirPage'
import qs from 'qs'
import { generateLoginUrlWithRedirect } from '@/utils/redirect'

const SplitPlanList = lazy(() => import('@/pages/cost/split'))

// 指标
const CollectorTemplate = lazy(() => import('@/pages/indicator/collectorTemplate'))
// 指标编辑
const CollectorTemplateEdit = lazy(() => import('@/pages/indicator/collectorTemplate/edit'))

// 合约模板
const ContractTemplate = lazy(() => import('@/pages/indicator/contractTemplate'))
// 合约模板编辑
const ContractTemplateEdit = lazy(() => import('@/pages/indicator/contractTemplate/edit'))

const EnterpriseSingle = lazy(() => import('@/pages/enterprise/single'))
const EnterpriseUnit = lazy(() => import('@/pages/enterprise/unit'))
const DictFeature = lazy(() => import('@/pages/dict/engineeringFeature'))
const DictInfo = lazy(() => import('@/pages/dict/projectInfo'))
const DictProject = lazy(() => import('@/pages/dict/engineeringSpecialty'))
// 项目信息
const ProjectInfo = lazy(() => import('@/pages/SystemSettings/Dict/ProjectInfo'))
// 造价指标-数据字典-工程信息
const ZjProjectInfo = lazy(() => import('@/pages/SystemSettings/Dict/ZjProjectInfo'))
// 造价指标-数据字典-估算工程信息
const GsProjectInfo = lazy(() => import('@/pages/SystemSettings/Dict/GsProjectInfo'))
// 造价指标-数据字典-科目属性
const SubjectAttributes = lazy(() => import('@/pages/SystemSettings/Dict/SubjectAttributes'))
// 基础项目信息
const BaseProjectDict = lazy(() => import('@/pages/SystemSettings/BaseDict/index'))
// 工程分类
const ProjectCategory = lazy(() => import('@/pages/SystemSettings/Dict/ProjectCategory'))
const AllocationRules = lazy(() => import('@/pages/SystemSettings/Dict/AllocationRules'))
// 造价阶段
const CostingPhase = lazy(() => import('@/pages/SystemSettings/Dict/CostingPhase'))
// 单据类型
const InvoiceType = lazy(() => import('@/pages/SystemSettings/Dict/InvoiceType'))
// 校验设置
const VerifySetting = lazy(() => import('@/pages/SystemSettings/Dict/Verify'))
// 指标标准
const Standard = lazy(() => import('@/pages/SystemSettings/Dict/IndicatorStandard'))
// 调差因子
const AdjustFactor = lazy(() => import('@/pages/SystemSettings/Dict/adjustFactor'))

const DictSort = lazy(() => import('@/pages/dict/engineeringClassification'))
const DictTemplate = lazy(() => import('@/pages/dict/engineeringQuantityIndicator'))
const DictTotal = lazy(() => import('@/pages/dict/overallMajor'))
const DictType = lazy(() => import('@/pages/dict/costType'))
const DictProfessional = lazy(() => import('@/pages/dict/professionalInformation'))

const IndicatorAdd = lazy(() => import('@/pages/indicator/edit'))
const IndicatorExamine = lazy(() => import('@/pages/indicator/examine'))
const IndicatorReviewList = lazy(() => import('@/pages/indicator/reviewList'))
const EnterpriseMaterial = lazy(() => import('@/pages/enterprise/material'))
const EnterpriseInventory = lazy(() => import('@/pages/enterprise/inventory'))
const EnterpriseProject = lazy(() => import('@/pages/enterprise/project'))
const EnterpriseIndex = lazy(() => import('@/pages/enterprise/index'))
const CostPlanList = lazy(() => import('@/pages/cost/list'))
const SingleCompare = lazy(() => import('@/pages/compare/single'))
const MultiCompare = lazy(() => import('@/pages/compare/multi'))

const GvTemplateList = lazy(() => import('@/pages/gvTemplate/list'))
const GvTemplateList2 = lazy(() => import('@/pages/indicator/gvTemplate'))
const TemplateList = lazy(() => import('@/pages/template/list'))
const LaborMaterialsMachinery = lazy(() => import('@/pages/inventory/laborMaterialsMachinery'))
const RationList = lazy(() => import('@/pages/inventory/ration'))
const SetIndicator = lazy(() => import('@/pages/inventory/components/setIndicator/main'))
const InventoryList = lazy(() => import('@/pages/inventory/list'))
const GvTemplateSetting = lazy(() => import('@/pages/gvTemplate/setting'))
const NewGvTemplateSetting = lazy(() => import('@/pages/indicator/gvTemplate/components/setting'))
const FieldList = lazy(() => import('@/pages/field/list'))
const PerformanceList = lazy(() => import('@/pages/cloudProject/index'))
const CloudProjectAnalysis = lazy(() => import('@/pages/cloudProject/analysis'))
const CloudProjectDocumentList = lazy(() => import('@/pages/cloudProject/documentList'))
// 项目中心
const ProjectCenter = lazy(() => import('@/pages/SystemSettings/ProjectCenterList'))
const EngList = lazy(() => import('@/pages/SystemSettings/EngList'))
const EngListEdit = lazy(() => import('@/pages/SystemSettings/EngList/edit'))
const IndicatorOperationLog = lazy(() => import('@/pages/SystemSettings/EngList/OperationLog'))
const Estimate = lazy(() => import('@/pages/SystemSettings/estimateList'))
const EstimateEdit = lazy(() => import('@/pages/SystemSettings/estimateList/edit'))
const ContractPlan = lazy(() => import('@/pages/SystemSettings/contractPlan'))
const ContractPlanEdit = lazy(() => import('@/pages/SystemSettings/contractPlan/edit'))
const IndicatorApplication = lazy(() => import('@/pages/indicator/application'))
const IndicatorReport = lazy(() => import('@/pages/indicator/application/Report'))
const DictFeatureList = lazy(() => import('@/pages/SystemSettings/Dict/Feature'))
const ProjectSpecial = lazy(() => import('@/pages/SystemSettings/Dict/ProjectSpecial'))
const ProjectStep = lazy(() => import('@/pages/SystemSettings/Dict/ProjectStep'))
const OpHistory = lazy(() => import('@/pages/SystemSettings/OpHistory'))
// 鲁班数据
const SystemDataGlj = lazy(() => import('@/pages/SystemSettings/data/glj'))
const SystemDataUnit = lazy(() => import('@/pages/SystemSettings/data/unit'))
const SystemDataUnitChange = lazy(() => import('@/pages/SystemSettings/data/unitChange'))
const SystemDataCollectTemplateRules = lazy(() => import('@/pages/SystemSettings/data/collectTemplateRules'))
const SystemDataCollectTemplateRulesEdit = lazy(() => import('@/pages/SystemSettings/data/collectTemplateRules/edit'))
const LogList = lazy(() => import('@/pages/log/index'))
// 申燃宝
const Shry = lazy(() => import('@/pages/shry'))
const FeeStandard = lazy(() => import('@/pages/shry/feeStandard'))
const UnitPriceStandard = lazy(() => import('@/pages/shry/unitPriceStandard'))
const UnitPriceStandardEdit = lazy(() => import('@/pages/shry/unitPriceStandard/edit'))
const ProjectStandard = lazy(() => import('@/pages/shry/projectStandard'))

// 简报看板
const IndicatorBriefSummary = lazy(() => import('@/pages/indicator/brief/summary'))

// 指标查询
const IndicatorKm = lazy(() => import('@/pages/indicator/view/km'))
const IndicatorEng = lazy(() => import('@/pages/indicator/view/eng'))
const IndicatorQdzhdj = lazy(() => import('@/pages/indicator/view/qdzhdj'))
const IndicatorGlj = lazy(() => import('@/pages/indicator/view/glj'))

// 指标应用
const IndicatorCostControlCompare = lazy(() => import('@/pages/indicator/apply/costControlCompare'))
const IndicatorCostControlCompareEdit = lazy(() => import('@/pages/indicator/apply/costControlCompare/edit'))
const IndicatorCostControlCompareResult = lazy(() => import('@/pages/indicator/apply/costControlCompare/result'))
const IndicatorStandard = lazy(() => import('@/pages/indicator/apply/standard'))
const IndicatorStandardEdit = lazy(() => import('@/pages/indicator/apply/standard/edit'))
// 系统设置
const IndicatorFeeStandard = lazy(() => import('@/pages/indicator/apply/fee-standard'))
const IndicatorFeeStandardEdit = lazy(() => import('@/pages/indicator/apply/fee-standard/edit'))
const DocumentDomainList = lazy(() => import('@/pages/documentCompile/domain/list'))
const TreeExample1 = lazy(() => import('@/pages/example/pages/treeExample1'))
const TailwindDemo = lazy(() => import('@/pages/example/pages/tailwind-demo'))


// 文档模板管理
const DocumentTemplateList = lazy(() => import('@/pages/documentCompile/template/documentTemp/index'))
const DocumentDirList = lazy(() => import('@/pages/documentCompile/template/dir/index'))
const DocumentPackageTemplateList = lazy(() => import('@/pages/documentCompile/template/package/index'))
const DocumentPackageTemplateListView = lazy(() => import('@/pages/documentCompile/template/package/components/viewManagement'))

// 基础信息管理
const DocumentEnterpriseInfo = lazy(() => import('@/pages/documentCompile/baseInfo/enterpriseInfo/index'))
const DocumentPersonInfo = lazy(() => import('@/pages/documentCompile/baseInfo/personInfo/index'))

// 数据字典管理
const DocumentEngDict = lazy(() => import('@/pages/documentCompile/dict/engDict/index'))
const DocumentProjectInfoDict = lazy(() => import('@/pages/documentCompile/dict/projectInfoDict/index'))
const DocumentEnterpriseInfoDict = lazy(() => import('@/pages/documentCompile/dict/enterpriseInfoDict/index'))
const DocumentPersonInfoDict = lazy(() => import('@/pages/documentCompile/dict/personInfoDict/index'))
const DocumentSignDict = lazy(() => import('@/pages/documentCompile/dict/signDict/index'))

// 云工程
const CloudProjectDictList = lazy(() => import('@/pages/cloudProject/dictList'))
const CloudProjectCodeRule = lazy(() => import('@/pages/cloudProject/codeRuleList'))
const CloudProjectBasePartner = lazy(() => import('@/pages/cloudProject/partner'))

// 新标签页面
// const Report = lazy(() => import('@/pages/Report'))
const ReportQdTab = lazy(() => import('@/pages/Report/newTab'))

// 规则新标签页
const NewTabRule = lazy(() => import('@/pages/newTab/rule'))

// center页面
const Role = lazy(() => import('@/pages/center/role/list'))

const lazyLoad = (children: React.ReactNode) => (
  <Suspense fallback={<Loading />}>{children}</Suspense>
)

const rootLoader = async () => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');
  // 首次访问直接跳转到登录页
  if (!token) {
    const storageToken = getStorage('token')
    if (!storageToken) {
      const loginUrl = generateLoginUrlWithRedirect()
      return redirect(loginUrl)
    }
  }

  // 这里是顶部菜单的key，用于高亮。如果当前路由不在这个key的列表里，需要跳转到默认的key到路由里
  // console.log('DefaultSystemKey')
  // console.log(DefaultSystemKey)
  // 所以这里获取到当前路由，如果路由不是当前菜单的，需要做处理
  return null
}

const routes = (
  <>
    {/* <Route path='/' loader={rootLoader} element={<Layout />} id='root' errorElement={<ErrorPage />}> */}
    <Route path='/' loader={rootLoader} element={<Layout />} id='root' errorElement={<ErrorPage />}>
      {/* FIXME: 去掉 errorElement 试试 */}
      {/* <Route path='/' loader={rootLoader} element={<Layout />} id='root' > */}
      {/* 默认跳转到指标项目列表 */}
      {/* <Route index element={<Navigate to='cloud-project/list' />} /> */}
      <Route path='/' element={<Navigate to='/indicator/englist' replace />} />

      <Route index path='analysis' element={lazyLoad(<CloudProjectAnalysis />)} />

      {/* 成本管控 */}
      <Route path='cost-control'>
        <Route path='contract-plan' element={lazyLoad(<ContractPlan />)} />
      </Route>

      {/* 项目指标 */}
      <Route path='indicator'>
        {/* 指标工程 */}
        <Route index element={<Navigate to='englist' />} />
        <Route path='englist' element={lazyLoad(<EngList />)} />
        <Route path='operlog' element={lazyLoad(<IndicatorOperationLog />)} />
        <Route path='shry' element={<Navigate to='/shry/list' replace />} />
        {/* <Route path='estimate' element={lazyLoad(<Estimate />)} /> */}
        {/* <Route path='application' element={lazyLoad(<IndicatorApplication />)} /> */}
        {/* <Route index element={<Navigate to='list' />} />
        <Route path='list' element={lazyLoad(<IndicatorList />)} /> */}
        {/* 报表 */}
        {/* <Route path='report' element={lazyLoad(<Report />)} /> */}
        <Route path='add' element={lazyLoad(<IndicatorAdd />)} />
        <Route path='edit' element={lazyLoad(<IndicatorAdd />)} />
        <Route path='reviewList' element={lazyLoad(<IndicatorReviewList />)} />
        <Route path='viewExamine' element={lazyLoad(<IndicatorExamine />)} />
        <Route path='examine' element={lazyLoad(<IndicatorExamine />)} />
        <Route path='detail' element={lazyLoad(<IndicatorExamine />)} />
        <Route path='singlecompare' element={lazyLoad(<SingleCompare />)} />
        <Route path='reviewSingle' element={lazyLoad(<SingleCompare />)} />
        <Route path='multicompare' element={lazyLoad(<MultiCompare />)} />
        <Route path='reviewMulti' element={lazyLoad(<MultiCompare />)} />

        {/* 指标指标模板 */}
        <Route path='collectorTemplate' element={lazyLoad(<CollectorTemplate />)} />
        <Route path='collectorTemplate/edit' element={lazyLoad(<CollectorTemplateEdit />)} />
        {/* 报表模板 */}
        <Route index path='officialTemplate' element={lazyLoad(<GvTemplateList />)} />
        <Route index path='officialTemplate2' element={lazyLoad(<GvTemplateList2 />)} />
        {/* 合约模板 */}
        <Route path='contractTemplate' element={lazyLoad(<ContractTemplate />)} />
        <Route path='contractTemplate/edit' element={lazyLoad(<ContractTemplateEdit />)} />
      </Route>

      {/* 简报看板 */}
      <Route path='/indicator-brief'>
        <Route path='summary' element={lazyLoad(<IndicatorBriefSummary />)} />
      </Route>

      {/* 指标查询 */}
      <Route path='indicator-view'>
        {/* 指标查询 */}
        <Route path='km' element={lazyLoad(<IndicatorKm />)} />
        <Route path='eng' element={lazyLoad(<IndicatorEng />)} />
        <Route path='qdzhdj' element={lazyLoad(<IndicatorQdzhdj />)} />
        <Route path='glj' element={lazyLoad(<IndicatorGlj />)} />
      </Route>

      {/* 指标应用 */}
      <Route path='indicator-apply'>
        <Route path='costControlCompare' element={lazyLoad(<IndicatorCostControlCompare />)} />
        <Route path='costControlCompare/edit' element={lazyLoad(<IndicatorCostControlCompareEdit />)} />
        <Route path='costControlCompare/Result' element={lazyLoad(<IndicatorCostControlCompareResult />)} />
        <Route path='standard' element={lazyLoad(<IndicatorStandard />)} />
        <Route path='standard/edit' element={lazyLoad(<IndicatorStandardEdit />)} />
        <Route path='application' element={lazyLoad(<IndicatorApplication />)} />
        {/* <Route path='indicator/report' element={lazyLoad(<IndicatorReport />)} /> */}
      </Route>

      {/* 企业指标 */}
      <Route path='enterprise'>
        <Route index path='index' element={lazyLoad(<EnterpriseIndex />)} />
        <Route path='project' element={lazyLoad(<EnterpriseProject />)} />
        <Route path='single' element={lazyLoad(<EnterpriseSingle />)} />
        <Route path='unit' element={lazyLoad(<EnterpriseUnit />)} />
        <Route path='inventory' element={lazyLoad(<EnterpriseInventory />)} />
        <Route path='material' element={lazyLoad(<EnterpriseMaterial />)} />
      </Route>
      {/* 内部数据字典 */}
      <Route path='systemDict'>
        <Route index path='total' element={lazyLoad(<DictTotal />)} />
        <Route path='baseDict' element={lazyLoad(<BaseProjectDict />)} />
        <Route path='project' element={lazyLoad(<DictProject />)} />
        <Route path='info2' element={lazyLoad(<ProjectInfo />)} />
        <Route path='info3' element={lazyLoad(<ZjProjectInfo />)} />
        <Route path='subjectAttr' element={lazyLoad(<SubjectAttributes />)} />
        <Route path='projectCategory' element={lazyLoad(<ProjectCategory />)} />
        <Route path='sort' element={lazyLoad(<DictSort />)} />
        <Route path='info' element={lazyLoad(<DictInfo />)} />
        <Route path='feature' element={lazyLoad(<DictFeature />)} />
        <Route path='feature2' element={lazyLoad(<DictFeatureList />)} />
        <Route path='projectSpecial' element={lazyLoad(<ProjectSpecial />)} />
        <Route path='projectStep' element={lazyLoad(<ProjectStep />)} />
        <Route path='type' element={lazyLoad(<DictType />)} />
        <Route path='template' element={lazyLoad(<DictTemplate />)} />
        <Route path='professional' element={lazyLoad(<DictProfessional />)} />
      </Route>
      <Route path='dict'>
        <Route index path='total' element={lazyLoad(<DictTotal />)} />
        <Route path='baseDict' element={lazyLoad(<BaseProjectDict />)} />
        <Route path='project' element={lazyLoad(<DictProject />)} />
        <Route path='info2' element={lazyLoad(<ProjectInfo />)} />
        <Route path='projectCategory' element={lazyLoad(<ProjectCategory />)} />
        <Route path='sort' element={lazyLoad(<DictSort />)} />
        <Route path='info' element={lazyLoad(<DictInfo />)} />
        <Route path='feature' element={lazyLoad(<DictFeature />)} />
        <Route path='feature2' element={lazyLoad(<DictFeatureList />)} />
        <Route path='projectSpecial' element={lazyLoad(<ProjectSpecial />)} />
        <Route path='projectStep' element={lazyLoad(<ProjectStep />)} />
        <Route path='type' element={lazyLoad(<DictType />)} />
        <Route path='template' element={lazyLoad(<DictTemplate />)} />
        <Route path='professional' element={lazyLoad(<DictProfessional />)} />
      </Route>
      <Route path='zjDict'>
        <Route path='info3' element={lazyLoad(<ZjProjectInfo />)} />
        <Route path='gsgc' element={lazyLoad(<GsProjectInfo />)} />
        <Route path='subjectAttr' element={lazyLoad(<SubjectAttributes />)} />
        <Route path='indicatorStandard' element={lazyLoad(<Standard />)} />
        <Route path='costingPhase' element={lazyLoad(<CostingPhase />)} />
        <Route path='InvoiceType' element={lazyLoad(<InvoiceType />)} />
      </Route>
      <Route path='zj-system'>
        {/* 分摊规则 */}
        <Route path='allocationRules' element={lazyLoad(<AllocationRules />)} />
        {/* 指标标准 */}
        <Route path='verifySetting' element={lazyLoad(<VerifySetting />)} />
        {/* 费率标准 */}
        <Route path='fee-standard' element={lazyLoad(<IndicatorFeeStandard />)} />
        <Route path='fee-standard/edit' element={lazyLoad(<IndicatorFeeStandardEdit />)} />
        <Route path='adjust-factor' element={lazyLoad(<AdjustFactor />)} />
      </Route>
      <Route path='systemData'>
        <Route path='glj' element={lazyLoad(<SystemDataGlj />)} />
        <Route path='unit' element={lazyLoad(<SystemDataUnit />)} />
        <Route path='unitChange' element={lazyLoad(<SystemDataUnitChange />)} />
        <Route path='collectTemplateRules' element={lazyLoad(<SystemDataCollectTemplateRules />)} />
        <Route path='collectTemplateRules/edit' element={lazyLoad(<SystemDataCollectTemplateRulesEdit />)} />
      </Route>

      {/* 清单定额 */}
      <Route path='inventory'>
        <Route index path='list' element={lazyLoad(<InventoryList />)} />
        <Route path='setIndicator' element={lazyLoad(<SetIndicator />)} />
        <Route path='ration' element={lazyLoad(<RationList />)} />
        <Route path='laborMaterialsMachinery' element={lazyLoad(<LaborMaterialsMachinery />)} />
      </Route>

      {/* 成本方案 */}
      <Route path='cost'>
        <Route index path='list' element={lazyLoad(<CostPlanList />)} />
        <Route path='split' element={lazyLoad(<SplitPlanList />)} />
      </Route>
      {/* 基础配置-项目模板 */}
      <Route path='template'>
        <Route index path='list' element={lazyLoad(<TemplateList />)} />
      </Route>
      <Route path='field'>
        <Route index path='list' element={lazyLoad(<FieldList />)} />
      </Route>
      {/* 后台日志 */}
      <Route path='log'>
        <Route index path='list' element={lazyLoad(<LogList />)} />
      </Route>

      {/* 基础配置-政府发布指标模板 */}
      <Route path='official-template'>
        <Route index path='list' element={lazyLoad(<GvTemplateList />)} />
        <Route index path='setting' element={lazyLoad(<GvTemplateSetting />)} />
      </Route>
      {/* <Route path='field'>
        <Route index path='list' element={<FieldList />} />
      </Route> */}

      {/* 项目业绩 */}
      <Route path='cloud-project'>
        <Route index path='list' element={lazyLoad(<PerformanceList />)} />
        <Route index path='analysis' element={lazyLoad(<CloudProjectAnalysis />)} />
        <Route index path='dict-list' element={lazyLoad(<CloudProjectDictList />)} />
        <Route index path='code-rule' element={lazyLoad(<CloudProjectCodeRule />)} />
        <Route index path='base-partner' element={lazyLoad(<CloudProjectBasePartner />)} />
        <Route index path='document-list' element={lazyLoad(<CloudProjectDocumentList />)} />
      </Route>

      {/* 项目中心 */}
      <Route path='project-center'>
        <Route index path='list' element={lazyLoad(<ProjectCenter />)} />
        {/* <Route index path='englist' element={lazyLoad(<EngList />)} /> */}
        {/* <Route index path='englist/edit' element={lazyLoad(<EngListEdit />)} /> */}
      </Route>

      {/* 投资估算 */}
      <Route path='investment'>
        <Route path='estimate' element={lazyLoad(<Estimate />)} />
        {/* <Route path='estimate/edit' element={lazyLoad(<EstimateEdit />)} /> */}
      </Route>

      {/* 资料文档 */}
      <Route path='document'>
        <Route index path='engList' element={lazyLoad(<DocumentList />)} />
        <Route path='engList/detail' element={lazyLoad(<DocumentDetail />)} />
        <Route path='engList/dir' element={lazyLoad(<DirPage />)} />
        {/* 字段域列表 */}
        <Route path='domainList' element={lazyLoad(<DocumentDomainList />)} />
        {/* 文档模板 */}
        <Route path='templateList' element={lazyLoad(<DocumentTemplateList />)} />
        {/* 文档目录 */}
        <Route path='dirList' element={lazyLoad(<DocumentDirList />)} />
        {/* 资料包模板 */}
        <Route path='packageTemplateList' element={lazyLoad(<DocumentPackageTemplateList />)} />
        {/* 资料包视图 */}
        <Route path='packageTemplateList/view' element={lazyLoad(<DocumentPackageTemplateListView />)} />
        {/* 企业信息 */}
        <Route path='enterpriseInfo' element={lazyLoad(<DocumentEnterpriseInfo />)} />
        {/* 人员信息 */}
        <Route path='personInfo' element={lazyLoad(<DocumentPersonInfo />)} />
        {/* 工程类型字典 */}
        <Route path='engDict' element={lazyLoad(<DocumentEngDict />)} />
        {/* 项目属性字典 */}
        <Route path='projectInfoDict' element={lazyLoad(<DocumentProjectInfoDict />)} />
        {/* 企业属性字典 */}
        <Route path='enterpriseInfoDict' element={lazyLoad(<DocumentEnterpriseInfoDict />)} />
        {/* 人员属性字典 */}
        <Route path='personInfoDict' element={lazyLoad(<DocumentPersonInfoDict />)} />
        {/* 签名身份字典 */}
        <Route path='signDict' element={lazyLoad(<DocumentSignDict />)} />
      </Route>

      {/* 上海燃气 */}
      <Route path='shry'>
        <Route index element={<Navigate to='list' replace />} />
        <Route path='list' element={lazyLoad(<Shry />)} />
        <Route path='material' element={<Navigate to='/shry/list' replace />} />
        <Route path='owner-supply' element={<Navigate to='/shry/list' replace />} />
        {/* 费率标准 */}
        <Route path='fee-standard' element={lazyLoad(<FeeStandard />)} />
        {/* 单价标准 */}
        <Route path='unit-price-standard' element={lazyLoad(<UnitPriceStandard />)} />
        {/* <Route path='unit-price-standard/edit' element={lazyLoad(<UnitPriceStandardEdit />)} /> */}
        {/* 标准化项目 */}
        <Route path='project-standard' element={lazyLoad(<ProjectStandard />)} />
      </Route>

      <Route path='*' element={<NoFind />} />
    </Route>
    <Route path='/login' element={lazyLoad(<Login />)} />
    {/* 无权限路由 */}

    {/* 测试组件 */}
    <Route path='test' element={<TestPage />} />
    <Route path='example' element={<ComponentsExample />} >
      <Route path='search' element={<BaseComponentStableSearch />} />
      <Route path='slickgrid' element={<BaseComponentSlickGrid />} />
      <Route path='edit-slickgrid' element={<EditComponentSlickGrid />} />
      <Route path='multiHeader' element={<MultiHeaderComponentSlickGrid />} />
      {/* EditComponentSlickGrid */}
      <Route path='rowGroup' element={<RowGroupSlickGrid />} />
      <Route path='treeSlickgrid' element={lazyLoad(<TreeComponentSlickGrid />)} />
      <Route path='lazySlickgrid' element={lazyLoad(<LazySlickgridSlickGrid />)} />
      <Route path='hearbeat' element={<HeartCheck />} />
      <Route path='react-query' element={<ReactQueryDemo />} />
      {/* 范围输入框 */}
      <Route path='input-range' element={<NumberRangeDemo />} />
      <Route path='datasource-select' element={<DataSourceSelectDemo />} />
      {/* 树勾选 */}
      <Route path='tree-check' element={<TreeExample1 />} />
      {/* Tailwind 示例 */}
      <Route path='tailwind-demo' element={lazyLoad(<TailwindDemo />)} />
    </Route>
    {/* center */}
    <Route path='center' element={<Role />} />

    {/* 造价指标-编辑指标工程 */}
    <Route index path='indicator/englist/edit' element={lazyLoad(<EngListEdit />)} errorElement={<ErrorPage />} />

    {/* 投资估算编辑新窗口 */}
    <Route path='investment/estimate/edit' element={lazyLoad(<EstimateEdit />)} />
    <Route path='cost-control/contract-plan/edit' element={lazyLoad(<ContractPlanEdit />)} />
    {/* 单价标准编辑新窗口 */}
    <Route path='shry/unit-price-standard/edit' element={lazyLoad(<UnitPriceStandardEdit />)} />


    {/* 项目中心编辑指标 */}
    <Route index path='project-center/englist/edit' element={lazyLoad(<EngListEdit />)} />
    {/* 操作历史记录 */}
    <Route index path='system/opHistory' element={lazyLoad(<OpHistory />)} />

    <Route path='qdTab' element={<ReportQdTab />} />
    <Route path='ruleTab' element={<NewTabRule />} />

    <Route index path='indicator/official-template/setting' element={lazyLoad(<GvTemplateSetting />)} />
    {/* <Route index path='indicator/report' element={lazyLoad(<IndicatorReport />)} /> */}
    <Route index path='indicator-apply/report' element={lazyLoad(<IndicatorReport />)} />


    <Route index path='official-template/newSetting' element={lazyLoad(<NewGvTemplateSetting />)} />


    {/* 其他页面 */}
    <Route path='other'  >
      <Route path='upload' element={<OtherUpload />} />
    </Route>
    {/* <Route path='*' element={<NoFind />} /> */}
  </>
)

export default routes
